export const colors = {
    // Unbridled Palette
    unbridledBlue: "#5a8ba7",
    unbridledGray: "#4b4f54",

    // Cornerstone Palette
    unbridledOrange: "#dc582a",
    unbridledGreen: "#799b3e",
} as const; 
